export enum ActionCustomEventEnum {
  DRIVER_LOCATION_UPDATE = 'driverLocationUpdate',
}
